<script setup lang="ts">
type Props = {
  productQuantity: number
  disabled?: boolean
}
defineProps<Props>()

const emit = defineEmits([
  'updateProductQuantity',
  'addToCart',
  'setIncreaseProduct',
  'setDecreaseProduct',
])

const { isDesktop } = useDevice()

onMounted(() => {
  emit('updateProductQuantity')
})

const addToCart = () => emit('addToCart')

const setIncreaseProduct = () => emit('setIncreaseProduct')

const setDecreaseProduct = () => emit('setDecreaseProduct')

const sizeButton = computed(() => (!isDesktop ? 'sm' : 'md'))
const fontButton = computed(() => (!isDesktop ? 'sm' : 'lg'))
</script>

<template>
  <div class="action">
    <the-button
      v-if="!productQuantity"
      class="action__button"
      :disabled="disabled"
      :size="sizeButton"
      :font="fontButton"
      radius="lg"
      @click="addToCart"
    >
      Хочу!
    </the-button>
    <the-counter
      v-else
      class="action__counter"
      :value="productQuantity"
      :size="sizeButton"
      @on-increase="setIncreaseProduct"
      @on-decrease="setDecreaseProduct"
    />
  </div>
</template>

<style lang="scss" scoped>
.action__button {
  width: 160px;

  @include media('<=desktop-mini') {
    width: 108px;
  }
}
</style>
